import React, { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

import logo from '../assets/images/logo.png';
import userIcon from '../assets/images/user.png';
import checkIcon from '../assets/images/check.png';
import passwordIcon from '../assets/images/password.png';
import { apiRequest } from '../utils/comman/apiRequest';
import { setSession } from '../utils/comman/authHelper';
import { Urls } from '../utils/endPoints/apiUrls';
import Loader from './comman/Loader';

export default function LoginPage() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const auth = useAuth();
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    setIsLoading(true)

    try {
      const { data, status } = await apiRequest({
        endUrl: Urls.userLogin,
        method: 'POST',
        body: { email: username, password },
        showMsg: true
      })
      if (status) {
        setSession(data.token);
        auth.login(data.token, () => navigate("/dashboard/flash"));
      }
    } catch (err) {
      setError(err.message);
    }
    finally {
      setIsLoading(false)
    }
  };


  return (
    <div className="bg-image">
      <div className="image-overlay"></div>

      <div className="container-fluid">
        <div className="row loginrow">
          <div className="col-lg-7 col-md-8 col-sm-12">
            <div className="left-heading">
              <button type="button" className="btn sleep-btn">Sleep Soundly!</button>
              <p className="mb-0 mt-3">You've explored the <br /> best mattresses.</p>
            </div>
          </div>

          <div className="col-lg-4 col-md-4 col-sm-12 p-0 d-flex justify-content-center align-items-center">
            <div className="loginbox">
              <img src={logo} alt="Logo" style={{ height: '18px' }} />

              <form className="row mt-5" onSubmit={handleSubmit}>
                <div className="col-12">
                  <h1 className="signin-heading">Hello, <br /> Welcome Back</h1>
                  <h1 className="signin-subheading">Hey, back to your special place!</h1>
                </div>

                <div className="col-12 mt-5">
                  <div className="input-wrapper">
                    <span className="input-icon-left">
                      <img src={userIcon} alt="User icon" />
                    </span>
                    <input
                      type="text"
                      placeholder="User Name"
                      value={username}
                      onChange={(e) => setUsername(e.target.value)}
                      required
                    />
                    <span className="input-icon-right">
                      <img src={checkIcon} alt="Check icon" />
                    </span>
                  </div>
                </div>

                <div className="col-12 mt-3">
                  <div className="input-wrapper">
                    <span className="input-icon-left">
                      <img src={passwordIcon} alt="Password icon" />
                    </span>
                    <input
                      type={showPassword ? 'text' : 'password'}
                      placeholder="Passcode"
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                      required
                    />
                    <p
                      className="mb-0 show-hide-txt"
                      onClick={() => setShowPassword(!showPassword)}
                      style={{ cursor: 'pointer' }}
                    >
                      {showPassword ? 'Hide' : 'Show'}
                    </p>
                  </div>
                </div>

                {error && (
                  <div className="col-12 mt-2">
                    <p style={{ color: 'red' }}>{error}</p>
                  </div>
                )}

                <div className="col-12 mt-5">
                  <button type="submit" className="signin-btn" disabled={isLoading}>
                    {isLoading ? (
                      <span className="login-spinner" role="status" aria-hidden="true"></span>
                    ) : (
                      'Sign In'
                    )}
                  </button>
                </div>
              </form>
            </div>
          </div>

          <div className="col-lg-7 col-md-8 col-sm-12"></div>

          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="copyright-text" style={{ marginTop: "-30pxpx" }}>
              <p className="mb-0 me-4">© 2025 All rights Reserved</p>
              <p className="mb-0">Privacy Policy</p>
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
